import { getItemMaker } from "./tools";

const splicer = getItemMaker("dna splicers");
export const dnaSplicers = [
  splicer("Sappy DNA Splicer", "DNAgun0"),
  splicer("Bolstered DNA Splicer", "DNAgun1"),
  splicer("Double Barreled DNA Splicer", "DNAgun2"),
  splicer("Ergonomic DNA Splicer", "DNAgun3"),
];
